import React from "react";

import {
  Card,
  Row,
  Col,
  Select,
  Button,
  Table,
  Tag,
  Space,
  Tooltip
} from "antd";

import {
  InboxOutlined
} from "@ant-design/icons";

const SSCCUnpacking = ({
  unpackableSSCCs = [],
  selectedSSCC,
  onSelectSSCC,
  onUnpack,
  unpackStatusList = [],
  loading = false,
  canUnpack = true
}) => {

  const columns = [
    {
      title: "SSCC Code",
      dataIndex: "sscc_code"
    },
    {
      title: "Level",
      dataIndex: "level",
      render: level => (
        <Tag
          color={
            level === "CS"
              ? "purple"
              : "green"
          }
        >
          {level}
        </Tag>
      )
    },
    {
      title: "Status",
      dataIndex:
        "unpack_status",
      render: status => {

        let color =
          "default";

        if (
          status ===
          "pending"
        ) {
          color = "orange";
        }

        if (
          status === "sent"
        ) {
          color = "green";
        }

        if (
          status ===
          "failed"
        ) {
          color = "red";
        }

        return (
          <Tag color={color}>
            {status}
          </Tag>
        );
      }
    },
    {
      title: "Retry",
      dataIndex:
        "unpack_retry_count"
    },
    {
      title: "Failure Reason",
      dataIndex: "unpack_failure_reason",
      width: 500,
      render: (text) => {
        if (!text) return "-";

        return (
          <Tooltip
            title={
              <div
                style={{
                  maxWidth: 700,
                  maxHeight: 400,
                  overflow: "auto",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word"
                }}
              >
                {text}
              </div>
            }
            placement="topLeft"
          >
            <div
              style={{
                maxWidth: 450,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: "pointer"
              }}
            >
              {text}
            </div>
          </Tooltip>
        );
      }
    },
    {
      title: "Message Id",
      dataIndex:
        "unpack_message_id"
    },
    {
      title: "Unpacked At",
      dataIndex:
        "unpacked_at"
    }
  ];

  return (
    <Card
      title="Unpacking"
      style={{
        marginTop: 20
      }}
    >

      <Row gutter={16}>

        <Col span={18}>
          <Select
            style={{
              width: "100%"
            }}
            disabled={!canUnpack}
            placeholder="Select SSCC to unpack"
            value={
              selectedSSCC
            }
            onChange={
              onSelectSSCC
            }
          >
            {
              unpackableSSCCs.map(
                item => (
                  <Select.Option
                    key={
                      item.id
                    }
                    value={
                      item.id
                    }
                  >
                    {
                      item.sscc_code
                    } (
                    {
                      item.level
                    }
                    )
                  </Select.Option>
                )
              )
            }
          </Select>
        </Col>

        <Col span={6}>
          <Button
            block
            type="primary"
            icon={
              <InboxOutlined />
            }
            onClick={
              onUnpack
            }
            loading={
              loading
            }
            disabled={
              !canUnpack ||
              !selectedSSCC ||
              loading
            }
          >
            Unpack
          </Button>
        </Col>

      </Row>

      <div
        style={{
          marginTop: 20
        }}
      >

        <Table
          size="small"
          rowKey="id"
          columns={columns}
          dataSource={
            unpackStatusList
          }
          pagination={false}
        />

      </div>

    </Card>
  );
};

export default SSCCUnpacking;